import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonIcon } from "@ionic/angular/standalone";
import { ModalStateService } from 'src/app/services/modal-service/modal-state.service';

@Component({
  selector: 'app-sticky-error-modal',
  templateUrl: './sticky-error-modal.component.html',
  styleUrls: ['./sticky-error-modal.component.scss'],
  imports: [IonIcon, TranslateModule]
})
export class StickyErrorModalComponent  implements OnInit {
  message!: string;
  modalState: ModalStateService;

  constructor() {
    this.modalState = inject(ModalStateService);
   }

  ngOnInit() {
    const state = this.modalState.getCurrentState();
		this.message = state.message;
  }

}
